const professions = [
  "Schlüsseldienst",
  "Elektriker",
  "Klempner/Installateur",
  "Automechaniker",
  "IT-Techniker",
  "Reisebüro",
  "Nachhilfelehrer",
  "Arzt (Hausarzt, Facharzt)",
  "Zahnarzt",
  "Hautarzt/Dermatologe",
  "Psychotherapeut",
  "Ernährungsberater",
  "Personal Trainer",
  "Physiotherapeut",
  "Kosmetiker",
  "Masseur",
  "Apotheker",
  "Versicherungsberater",
  "Finanzberater",
  "Steuerberater",
  "Immobilienmakler",
  "Rechtsanwalt",
  "Notar",
  "Fotograf",
  "Friseur",
  "Make-up-Artist",
  "Social-Media-Manager",
  "Grafikdesigner",
  "Tanzlehrer",
  "Hundetrainer",
  "Tierarzt",
  "Babysitter",
  "Haushälter/in",
  "Eventorganisator",
  "Cateringservice",
  "Bäcker",
  "Barista",
  "Lieferservice für Lebensmittel",
  "Umzugsservice",
  "Haushaltshelfer",
  "Fahrlehrer",
  "Software as a Service",
];

const reducedProfessions = [
  "Immobilienmakler",
  "Versicherungsberater",
  "Finanzberater",
  "Rechtsanwalt",
];

function sortStringsByAlphabet(array) {
  // Filter nur Strings aus dem Array
  const stringElements = array.filter((item) => typeof item === "string");

  // Strings alphabetisch sortieren
  stringElements.sort((a, b) => a.localeCompare(b));

  return stringElements;
}

export default reducedProfessions;
